<template>
  <div>
    <!-- begin breadcrumb -->
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item active">
        <a href="javascript:;">账号设置</a>
      </li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      支付、小程序、公众号
      <small>设置各种账号信息,必须慎重修改...</small>
    </h1>
    <!-- end page-header -->
    <panel title="支付设置">
      <div class="row content">
        <div class="col-md-6">
          <!-- 关于我们设置 -->
          <Card :bordered="false">
            <p slot="title">微信支付设置</p>
            <Form :labelWidth="150">
              <FormItem label="appid">
                <Input v-model="minprogrampay.app_id" />
              </FormItem>
              <FormItem label="mch_id">
                <Input v-model="minprogrampay.mch_id" />
              </FormItem>
              <FormItem label="key">
                <Input v-model="minprogrampay.key" />
              </FormItem>
              <FormItem label="cert_path">
                <Input v-model="minprogrampay.cert_path" />
              </FormItem>
              <FormItem label="key_path">
                <Input v-model="minprogrampay.key_path" />
              </FormItem>
              <FormItem label="notify_url">
                <Input v-model="minprogrampay.notify_url" />
              </FormItem>

              <FormItem>
                <button
                  type="button"
                  class="btn btn-theme btn-sm"
                  @click="fn_save_minprogrampay"
                >保存配置</button>
              </FormItem>
            </Form>
          </Card>
        </div>
        <div class="col-md-6">
          <Card :bordered="false">
            <p slot="title">小程序配置</p>
            <Form :labelWidth="150">
              <FormItem label="appid">
                <Input v-model="minprogram.app_id" />
              </FormItem>
              <FormItem label="app-secret">
                <Input v-model="minprogram.secret" />
              </FormItem>
              <FormItem>
                <button type="button" class="btn btn-theme btn-sm" @click="fn_save_minprogram">保存配置</button>
              </FormItem>
            </Form>
          </Card>
          <Card :bordered="false">
            <p slot="title">公众号配置</p>
            <Form :labelWidth="150">
              <FormItem label="appid">
                <Input v-model="formofficial.app_id" />
              </FormItem>
              <FormItem label="app-secret">
                <Input v-model="formofficial.secret" />
              </FormItem>
              <FormItem label="token">
                <Input v-model="formofficial.token" />
              </FormItem>
              <FormItem label="ase_key">
                <Input v-model="formofficial.aes_key" />
              </FormItem>
              <FormItem label="rediect_url">
                <Input v-model="formofficial.redirect_url" />
              </FormItem>
              <FormItem>
                <button type="button" class="btn btn-theme btn-sm" @click="fn_save_offical">保存配置</button>
              </FormItem>
            </Form>
          </Card>
        </div>
      </div>
    </panel>
  </div>
</template>
<script>
import giftcomponent from "./giftcomponent";

import {
  getMinProgramPaySet,
  saveMinProgramPaySet,
  getMinProgramSet,
  saveMinProgramSet,
  getOfficalAccountSet,
  saveOfficalAccountSet
} from "@/api/config";

export default {
  components: { giftcomponent },
  data() {
    return {
      minprogrampay: {
        app_id: "",
        mch_id: "",
        key: "",
        cert_path: "",
        key_path: "",
        notify_url: ""
      },
      minprogram: {
        app_id: "",
        secret: ""
      },
      formofficial: {
        app_id: "",
        secret: "",
        token: "",
        aes_key: "",
        redirect_url: ""
      }
    };
  },
  mounted() {
    getMinProgramPaySet()
      .then(res => {
        this.minprogrampay = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });

    getMinProgramSet()
      .then(res => {
        this.minprogram = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
    getOfficalAccountSet()
      .then(res => {
        this.formofficial = res.data;
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  methods: {
    fn_save_minprogrampay() {
      saveMinProgramPaySet(this.minprogrampay)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error("错误", error);
        });
    },
    fn_save_minprogram() {
      saveMinProgramSet(this.minprogram)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    fn_save_offical() {
      saveOfficalAccountSet(this.formofficial)
        .then(res => {
          if (res.data.code == 200) {
            this.$Notice.success(res.data);
          } else {
            this.$Notice.error(res.data);
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  }
};
</script>